<template>
  <table class="table fee-summary is-hoverable">
    <tbody>
      <tr>
        <th>Conference Fee</th>
        <td>{{ baseFee.toFixed(2) }} €</td>
      </tr>
      <tr>
        <th>Discount</th>
        <td>{{ discounts.toFixed(2) }} €</td>
      </tr>
      <tr>
        <th>Extra fees (pages, proceedings)</th>
        <td>{{ extraFees.toFixed(2) }} €</td>
      </tr>
      <tr>
        <th>Accompanying person</th>
        <td>{{ accompanyingPerson.toFixed(2) }} €</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <th>Total</th>
        <td>
          <strong class="is-medium">{{ totalFee.toFixed(2) }} €</strong>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
export default {
  name: "FeeSummary",
  props: ["baseFee", "discounts", "extraFees", "accompanyingPerson", "totalFee"],
};
</script>

<style scoped>
.table.fee-summary {
  width: auto;
}
.table.fee-summary td {
  text-align: right;
}
</style>
